/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The GoalsidGoalTargetsAttributes model module.
 * @module model/GoalsidGoalTargetsAttributes
 * @version v0.3
 */
export default class GoalsidGoalTargetsAttributes {
  /**
   * Constructs a new <code>GoalsidGoalTargetsAttributes</code>.
   * @alias module:model/GoalsidGoalTargetsAttributes
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>GoalsidGoalTargetsAttributes</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GoalsidGoalTargetsAttributes} obj Optional instance to populate.
   * @return {module:model/GoalsidGoalTargetsAttributes} The populated <code>GoalsidGoalTargetsAttributes</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GoalsidGoalTargetsAttributes();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('target_template_id'))
        obj.targetTemplateId = ApiClient.convertToType(data['target_template_id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('value'))
        obj.value = ApiClient.convertToType(data['value'], 'String');
      if (data.hasOwnProperty('observation_type_id'))
        obj.observationTypeId = ApiClient.convertToType(data['observation_type_id'], 'String');
      if (data.hasOwnProperty('tag_list'))
        obj.tagList = ApiClient.convertToType(data['tag_list'], ['String']);
    }
    return obj;
  }
}

/**
 * Provide a target ID only when you want to update an existing target
 * @member {String} id
 */
GoalsidGoalTargetsAttributes.prototype.id = undefined;

/**
 * ID of the associated target template
 * @member {String} targetTemplateId
 */
GoalsidGoalTargetsAttributes.prototype.targetTemplateId = undefined;

/**
 * Name of the target
 * @member {String} name
 */
GoalsidGoalTargetsAttributes.prototype.name = undefined;

/**
 * Description of the target
 * @member {String} description
 */
GoalsidGoalTargetsAttributes.prototype.description = undefined;

/**
 * The target value
 * @member {String} value
 */
GoalsidGoalTargetsAttributes.prototype.value = undefined;

/**
 * ID of the relevant observation type
 * @member {String} observationTypeId
 */
GoalsidGoalTargetsAttributes.prototype.observationTypeId = undefined;

/**
 * Add an array of strings to help manage your resources
 * @member {Array.<String>} tagList
 */
GoalsidGoalTargetsAttributes.prototype.tagList = undefined;

